import styled from 'styled-components'

import bgImg from '@/assets/bg/settings-bg.png'

import { QrContainer, QrContainerBg } from '../styles'

export const RegisterContainer = styled('main')<{
  $promotionData: boolean
}>`
  display: flex;
  height: 100vh;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
  margin-left: ${(props) => (props.$promotionData ? '0px;' : '152px')};
`
export const SessionContainer = styled('main')`
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 112px 0 72px;
  margin-left: 152px;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: auto 900px;
`

export const LoginContainer = styled(RegisterContainer)``

export const PromoWrapper = styled('div')`
  display: flex;
  height: 1080px;
  flex: 1;
  min-width: 50%;
  overflow: hidden;
`

export const PromoImg = styled.img`
  object-fit: cover;
`

export const RegisterWrapper = styled('div')`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  flex: 1;
  min-width: 50%;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: auto 900px;
`

export const RegisterQrContainer = styled(QrContainer)`
  margin-top: 65px;
`

export const LoginWrapper = styled(RegisterWrapper)<{
  $promotionData: boolean
}>`
  padding: ${(props) => (props.$promotionData ? '0px;' : '0 112px 0 72px;')};
`

export const ButtonWrapper = styled('div')`
  position: relative;
  border-top: 2px solid ${(props) => props.theme.colors.register.separator};
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TextElem = styled('div')`
  margin-bottom: 32px;
  color: ${(props) => props.theme.colors.register.text};
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
`

export const QrContainerLogin = styled(QrContainerBg)`
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  background: none;
  margin-bottom: 0;
  padding: 40px;
`

export const LogoPanel = styled.div`
  height: 35px;
  width: 277px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 30px;
  padding: 0 15px;
`

export const LogoIcon = styled.img`
  max-height: 35px;
  opacity: 0.7;
`

export const ButtonBack = styled.div<{
  $dark: boolean
}>`
  position: absolute;
  top: 66px;
  left: 50px;
  background: ${(props) =>
    props.$dark ? props.theme.colors.register.backBtnBg : 'none'};
  box-shadow: ${(props) =>
    props.$dark
      ? `0 0 0 5px ${props.theme.colors.register.backBtnBg}`
      : 'none'};
`

export const SkipWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0 60px;
`

export const LoginSkipWrapper = styled.div`
  position: absolute;
  bottom: -8px;
  right: 20px;
`
